import React, { useRef, useState } from 'react';
import { IoChevronDownOutline } from 'react-icons/io5';
import { formKeys } from '../../../constants/constants';
import styles from './TypeView.module.scss';
import SubTypeView from '../SubTypeView/SubTypeView';

function SymptomsList({ list = [] }) {
  if (!list?.length) return null;
  return (
    <div className={styles.symptoms}>
      {list.map((c) => (
        <div key={c._id || c} className={styles.symptom}>
          <p>{typeof c === 'string' ? c : (c.name || c.label || c)}</p>
        </div>
      ))}
    </div>
  );
}

export default function TypeView({ type }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef();
  const symptoms = type?.symptoms || [];

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h2>{type?.name}</h2>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className={`${styles.toggle} ${isOpen ? styles.open : ''}`}
        >
          <IoChevronDownOutline size={20} />
        </button>
      </div>
      <div
        className={styles['section-content']}
        style={{ display: isOpen ? 'block' : 'none' }}
      >
        <div ref={contentRef}>
          {formKeys.map((k) => {
            const key = type?.[k.value];
            if (key && key.isDisplayed) {
              return (
                <div key={`${k.value}-mutation`} className={styles.block}>
                  <label>{k.label}</label>
                  <p>{key.value}</p>
                </div>
              );
            }
            return null;
          })}
          {(type?.mutationsDescription || type?.symptomsDescription || symptoms.length > 0) && (
            <>
              <h3>Mutations & symptomes</h3>
              {type?.mutationsDescription && (
                <div className={styles.block}>
                  <label>Description des mutations</label>
                  <p>{type.mutationsDescription}</p>
                </div>
              )}
              {symptoms.length > 0 && (
                <div className={styles.block}>
                  <label>Symptomes</label>
                  <SymptomsList list={symptoms} />
                </div>
              )}
              {type?.symptomsDescription && (
                <div className={styles.block}>
                  <label>Description des symptoms</label>
                  <p>{type.symptomsDescription}</p>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {type?.subtypes?.map((t) => (
        <SubTypeView key={t._id || t.name} type={t} />
      ))}
    </div>
  );
}
